module.exports = __webpack_public_path__ + "img/Governance.234ef143.png";